import { useCallback } from 'react'

import { useHasFinalizedPricing } from './providers/EmployerProvider'

export const emitEmployerRenewalsEvent = (event: string, isPreliminaryPricing: boolean, data?: Record<string, any>) => {
  window.segment?.track(`[ER] Renewals: ${event}`, {
    ...data,
    preliminary: isPreliminaryPricing,
  })
}

export function useEmitEmployerRenewalsEvent () {
  const hasFinalizedPricing = useHasFinalizedPricing()

  const emitEvent = useCallback((event: string, data?: Record<string, any>) => {
    emitEmployerRenewalsEvent(event, !hasFinalizedPricing, data)
  }, [hasFinalizedPricing])

  return {
    emitEvent,
  }
}

export const RENEWAL_EVENTS = {
  DASHBOARD_BANNER_CLICKED: 'dashboard banner clicked',
  SUPPORT_LINK_CLICKED: 'get support link clicked',
  CENSUS_FAILED: 'census failed',
  EMPLOYEE_FILTER_CHANGED: 'review costs review toggle currently enrolled vs eligible',
  FLAT_ALLOWANCE_APPROACH_CHANGED: 'flat allowance toggle recommended',
  SMART_ALLOWANCE_APPROACH_REDUCE_CLICKED: 'smart allowance reduce benefits clicked',
  SMART_ALLOWANCE_APPROACH_UPGRADE_CLICKED: 'smart allowance upgrade benefits clicked',
  SMART_ALLOWANCE_APPROACH_MATCH_CLICKED: 'smart allowance maintain benefits clicked',
  QME_TOGGLED_ON: 'QME enable toggled on',
  QME_TOGGLED_OFF: 'QME enable toggled off',
  ADDED_DEPENDENT_COVERAGE: 'added dependent coverage',
}
